import React, { useEffect, useState } from "react";
import { Modal } from "../../../components/Modal";
import { Input } from "../../../components/Input";
import { theme } from "../../../styles/theme";
import { Div, Text } from "../../../styles/Common";
import { Alert, Col, Divider, Row } from "antd";
import { Button } from "../../../components/Button";
import { Link } from "../../../components/Link";
import addIcon from "../../../assets/icons/add.svg";
import deleteIcon from "../../../assets/icons/trash-salmon.svg";
import { SelectMultiple } from "../../../components/SelectMultiple";
import useCreateContractorCompany from "../hooks/useCreateContractorCompany";
import useCreateUser from "../hooks/useCreateUser";
import { Select } from "../../../components/Select";
import { getPhoneLengthByCountry } from "../../../utilities/helpers";

export const AddUserModal = ({
  openCreate,
  handleClose,
  refetchUsers,
  contractorCompaniesOptions,
  refetch,
  codeOptions,
}) => {
  const createUser = useCreateUser();
  const [addCompany, setAddCompany] = useState(false);
  const createContractorCompany = useCreateContractorCompany();
  const [newCompanyName, setNewCompanyName] = useState("");
  const [companyContractorListId, setCompanyContractorListId] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageCompany, setErrorMessageCompany] = useState("");
  const [companiesError, setCompaniesError] = useState(false);
  const [usersInfo, setUsersInfo] = useState([
    {
      id: 1,
      userName: "",
      userLastName: "",
      userEmail: "",
      phoneCodeId: 13,
      phoneNumber: "",
    }
  ]);
  const [fieldErrors, setFieldErrors] = useState({});

  const handleAdd = () => {
    setUsersInfo([...usersInfo, {
      id: usersInfo.length + 1,
      userName: "",
      userLastName: "",
      userEmail: "",
      phoneCodeId: 13,
      phoneNumber: "",
    }]);
  };

  const handleDelete = (index) => {
    const currentUsersInfo = [...usersInfo];
    const newUsersInfo = currentUsersInfo.filter((_, i) => i !== index);
    setUsersInfo(newUsersInfo);
  };

  const handleCancel = () => {
    handleClose();
    setCompanyContractorListId([]);
    setAddCompany(false);
    setNewCompanyName("");
    setErrorMessage("");
    setErrorMessageCompany("");
    setFieldErrors({});
    setCompaniesError(false);
    setUsersInfo([
      {
        id: 1,
        userName: "",
        userLastName: "",
        userEmail: "",
        phoneCodeId: 13,
        phoneNumber: "",
      }
    ])
  };

  const handleChange = (event, index) => {
    const { id, value } = event.target;
    const currentUsersInfo = [...usersInfo];
    currentUsersInfo[index][id] = value;
    setUsersInfo(currentUsersInfo);
    
    if (fieldErrors[`${id}_${index}`]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[`${id}_${index}`];
        return newErrors;
      });
    }
  };

  const handleChangeNumber = (event, index) => {
    const { id, value } = event.target;
    const currentUsersInfo = [...usersInfo];
    currentUsersInfo[index][id] = value.replace(/[^0-9]/g, "");
    setUsersInfo(currentUsersInfo);
    
    if (fieldErrors[`${id}_${index}`]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[`${id}_${index}`];
        return newErrors;
      });
    }
  };

  const handleSelect = (value, index) => {
    const currentUsersInfo = [...usersInfo];
    currentUsersInfo[index].phoneCodeId = value;
    setUsersInfo(currentUsersInfo);
  };

  const getMaxLengthForUser = (phoneCodeId) => {
    const countryCode = codeOptions?.find(option => option.value === phoneCodeId)?.label;
    return getPhoneLengthByCountry(countryCode);
  };

  const handleCreateCompany = () => {
    if (newCompanyName !== "") {
      createContractorCompany.reset();
      createContractorCompany.mutate(newCompanyName, {
        onSuccess: (response) => {
          refetch();
          setAddCompany(false);
          setNewCompanyName("");
          setCompanyContractorListId([...companyContractorListId, response?.data?.Result]);
        }
      });
    }
  };

  const handleSelectCompany = (value) => {
    setCompanyContractorListId(value);
    setCompaniesError(false);
  };

  const handleSendInvitation = () => {
    if (companyContractorListId.length === 0) {
      setCompaniesError(true);
    }

    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emails = [];
    
    usersInfo.forEach((user, index) => {
      if (!user.userName.trim()) errors[`userName_${index}`] = true;
      if (!user.userLastName.trim()) errors[`userLastName_${index}`] = true;
      if (!user.userEmail.trim() || !emailRegex.test(user.userEmail)) errors[`userEmail_${index}`] = true;
      if (!user.phoneCodeId) errors[`phoneCodeId_${index}`] = true;
      if (!user.phoneNumber.trim()) errors[`phoneNumber_${index}`] = true;
      
      if (user.userEmail.trim()) {
        const emailLower = user.userEmail.trim().toLowerCase();
        if (emails.includes(emailLower)) {
          errors[`userEmail_${index}`] = true;
        } else {
          emails.push(emailLower);
        }
      }
    });

    if (companyContractorListId.length === 0 || Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    const payload = {
      companyContractorListId: companyContractorListId,
      createUsers: usersInfo.map(user => ({
        userName: user.userName,
        userLastName: user.userLastName,
        userEmail: user.userEmail,
        phoneCodeId: user.phoneCodeId,
        phoneNumber: user.phoneNumber,
      }))
    };

    createUser.reset();
    createUser.mutate(payload, {
      onSuccess: () => {
        handleCancel();
        refetchUsers();
      },
      onError: (err) => {
        setErrorMessage(err.response.data.Errors[0]);
      }
    });
  };

  return (
    <Modal
      open={openCreate}
      onCancel={handleCancel}
      align={"left"}
      padding={"41px 39px"}
      width={"976px"}
    >
      <Modal.Header 
        padding="16px 0 16px 0" 
        title={"Add New User"} 
        align={"flex-start"} 
        subtitle={"Add users by Company. Select a Company to assign, then enter the user details. You can add multiple users at once."} 
      />
      <Modal.Body
        margin="0 0 24px 0"
        maxHeight={400}
        style={{ paddingRight: "24px" }}
      >
        <Div direction="column" gap="16px">
          <Text
            size={theme.fonts.size.h6}
            color={theme.colors.dark}
            weight={theme.fonts.weight.medium}
          >
            Select Company
          </Text>
          {!addCompany ? (
            <SelectMultiple
              options={contractorCompaniesOptions}
              placeholder="Select Company"
              autoComplete="off"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              notFoundContent="Data not found"
              showSearch
              value={companyContractorListId}
              onChange={handleSelectCompany}
              style={{ width: "338px" }}
              error={companiesError}
              helper={companiesError ? "Please select a company" : ""}
              dropdownRender={(menu) => (
                <div>
                  {menu}
                  <Divider style={{ margin: '12px 0 0 0' }} />
                  <Link 
                    color={theme.colors.salmon}
                    style={{ padding: "0 0 0 10px" }}
                    onClick={() => setAddCompany(true)}
                  >
                    + Add Company
                  </Link>
                </div>
              )}
            />
          ) : (
            <Div gap="16px">
              <Input 
                id="companyName" 
                placeholder="Company Name" 
                value={newCompanyName}
                onChange={(event) => setNewCompanyName(event.target.value)} 
                width="338px"
              />
              <Link 
                onClick={() => {
                  setAddCompany(false);
                  setNewCompanyName("");
                  setErrorMessageCompany("");
                }}
              >
                Cancel
              </Link>
              <Button 
                background={theme.colors.salmon} 
                width="100px"
                onClick={handleCreateCompany}
                loading={createContractorCompany.isLoading}
              >
                Save
              </Button>
            </Div>
          )}
          {errorMessageCompany !== "" && (
            <Div m="0 0 20px 0" justify="flex-start">
              <Alert closable message={`${errorMessageCompany}`} type="error" />
            </Div>
          )}
        </Div>
        <Div direction="column" gap="24px">
          <Text
            size={theme.fonts.size.h6}
            color={theme.colors.dark}
            weight={theme.fonts.weight.medium}
            mt="32px"
          >
            Select users to invite
          </Text>
          {usersInfo.map((user, index) => (
            <Div key={user.id}>
              <Row gutter={[13, 16]}>
                <Col md={12}>
                  <Input 
                    id="userName" 
                    placeholder="Name" 
                    onChange={(event) => handleChange(event, index)} 
                    value={user.userName}
                    error={fieldErrors[`userName_${index}`]}
                    helper={fieldErrors[`userName_${index}`] ? "Required field" : ""}
                  />
                </Col>
                <Col md={12}>
                  <Input 
                    id="userLastName" 
                    placeholder="Lastname" 
                    onChange={(event) => handleChange(event, index)} 
                    value={user.userLastName}
                    error={fieldErrors[`userLastName_${index}`]}
                    helper={fieldErrors[`userLastName_${index}`] ? "Required field" : ""}
                  />
                </Col>
                <Col md={12}>
                  <Input 
                    id="userEmail" 
                    placeholder="Email Address" 
                    onChange={(event) => handleChange(event, index)} 
                    value={user.userEmail}
                    error={fieldErrors[`userEmail_${index}`]}
                    helper={fieldErrors[`userEmail_${index}`] ? 
                      user.userEmail.trim() === "" ? "Required field" : 
                      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.userEmail) ? "Invalid email" :
                      "Email already exists in this form" : ""}
                  /> 
                </Col>
                <Col md={3}>
                  <Select
                    id="phoneCodeId"
                    options={codeOptions}
                    placeholder="Code"
                    onChange={(value) => handleSelect(value, index)}
                    value={user.phoneCodeId}
                    error={fieldErrors[`phoneCodeId_${index}`]}
                    helper={fieldErrors[`phoneCodeId_${index}`] ? "Required field" : ""}
                  />
                </Col>
                <Col md={9}>
                  <Input 
                    id="phoneNumber" 
                    placeholder="Phone Number" 
                    onChange={(event) => handleChangeNumber(event, index)} 
                    value={user.phoneNumber}
                    maxLength={getMaxLengthForUser(user.phoneCodeId)}
                    error={fieldErrors[`phoneNumber_${index}`]}
                    helper={fieldErrors[`phoneNumber_${index}`] ? "Required field" : ""}
                  /> 
                </Col>
              </Row>
              <Div m="0 0 0 16px" style={{ visibility: index === 0 ? "hidden" : "visible" }}>
                <Link width="min-content" onClick={() => handleDelete(index)}>
                  <Div align="center" gap="4px">
                    <img alt="delete" src={deleteIcon} />
                    Delete
                  </Div>
                </Link>
              </Div>
            </Div>
          ))}
        </Div>
        <Link width="min-content" onClick={handleAdd}>
          <Div align="center" gap="7px">
            <img alt="add" src={addIcon} />
            Add User
          </Div>
        </Link>
      </Modal.Body>
      <Modal.Footer style={{ flexDirection: "column" }}>
        {errorMessage !== "" && (
          <Div m="0 0 20px 0" justify="flex-end">
            <Alert closable message={`${errorMessage}`} type="error" />
          </Div>
        )}
        <Div gap="32px" justify="center">
          <Button
            onClick={handleCancel}
            border={theme.colors.dark}
            color={theme.colors.dark}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSendInvitation}
            background={theme.colors.salmon}
            loading={createUser.isLoading}
          >
            Send Invitation
          </Button>
        </Div>
      </Modal.Footer>
    </Modal>
  )
};